// Texts
export const headerDefault = 'Warning' // warning text
export const btnTextDefault = 'Close' // button text

// Colors
export const errorColor = 'rgb(220, 53, 69)' // '#dc3545'
export const warningColor = 'rgb(255, 193, 7)' // '#28a745'
export const successColor = 'rgb(40, 167, 69)' // '#ffc107'
export const defaultColor = 'rgb(51, 51, 51)' // '#333'
